import { useState, useEffect, useRef } from 'react';
import './photo-input.css';
import close from '../../imgs/close.png';

function PhotoInput({ initials, photo, onChange, onRemove }) {
    const [preview, setPreview] = useState(undefined);
    const fileInputRef = useRef(null);

    useEffect(() => {
        if (!photo) {
            setPreview(undefined);
            return;
        }

        const objectUrl = URL.createObjectURL(photo);
        setPreview(objectUrl);

        return () => URL.revokeObjectURL(objectUrl);
    }, [photo]);


    function onClickChoosePhoto(e) {
        e.preventDefault();
        fileInputRef.current.click();
    }

    function onChangePhoto(e) {
        const file = e.target.files[0];
        if (!file)
            return;

        setPreview(URL.createObjectURL(file));
        onChange(file);
    }

    function onClickRemovePhoto() {
        setPreview(undefined);
        onRemove();
    }

    return (
        <div className='photo-container'>
            {!photo && (<div className="photo-img">{initials}</div>)}
            {!!photo && (
                <>
                    <button type='button' className='remove-img' onClick={onClickRemovePhoto}>
                        <img src={close} alt='Remover foto' />
                    </button>
                    <img className="photo-img" src={preview} alt="Foto do usuário" />
                </>
            )}
            <input
                ref={fileInputRef}
                type="file"
                accept="image/*"
                onChange={onChangePhoto}
                hidden
            />
            <button type="button" className='photo-button blue-button zoom-effect' onClick={onClickChoosePhoto}>Carregar imagem</button>
        </div>
    );
}

export default PhotoInput;